import dayjs from "dayjs";
import crypto from "crypto-js";

export const generateMRN = (email: string, numbericLength = 9) => {
  const timestamp = dayjs().toISOString();
  const seed = email + timestamp;
  const hash = crypto.SHA256(seed).toString();
  const numHash = BigInt(`0x${hash}`).toString();
  const charList: string[] = [];
  const pivot = Math.floor(numHash.length / numbericLength);
  let index = 0;
  for (let i = 0; i < numbericLength; i++) {
    index += pivot;
    charList.push(numHash[index % numHash.length]);
  }
  const finalNumHash = charList.join("");
  return `MRN${finalNumHash}`;
};
